import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { NewmemberService } from '../../services/newmember.service';

@Component({
  selector: 'app-infoform',
  templateUrl: './infoform.component.html',
  styleUrls: ['./infoform.component.css']
})
export class InfoformComponent implements OnInit {

  memberDetails: any = {};
  blockSpecial: RegExp = /^[^0-9<>*!@#$_%+=~`^{}()-/\\;:.,&|?\[\]'"]*$/;
  populateForm: any = {};
  bi: any = {};
  biForm: FormGroup;
  biVerified: boolean = true;
  biFormValid: boolean = true;
  constructor(public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              public nms: NewmemberService,
              public messageService: MessageService) { }

  ngOnInit() {
    this.populateForm = this.config.data.populateForm;
    this.bi.firstName = this.config.data.memberDetails.firstName;
    this.bi.middleName = this.config.data.memberDetails.middleName;
    this.bi.lastName = this.config.data.memberDetails.lastName;
    this.bi.phoneNbr = this.config.data.memberDetails.phoneNbr;
    this.bi.extensionNbr = this.config.data.memberDetails.extensionNbr;
    this.bi.marketCommunication = this.config.data.memberDetails.acceptMarketingCall;

    this.biForm = new FormGroup({
      marketCommunication: new FormControl(),
      firstName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      middleName: new FormControl(),
      lastName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mselected: new FormControl(),
    });
  }

  updateOTPstatus(event) {
    this.biVerified = event;
  }

  resetOTP() {
    this.biVerified = false;
  }

  saveInfo() {
    if (this.biForm.valid && this.biForm.dirty) {
      this.nms.saveInfo(this.bi).subscribe((res: any) => {
        if (res.code === 'SUCCESS') {
          this.ref.close(true);
        }
      }, err => {
        console.error('ERROR', err);
      });
    } else {
      if (!this.biForm.valid) {
        this.biFormValid = false;
        this.msgToast('Please fill all mandatory fields');
      } else {
        this.msgToast('No changes made');
      }
    }
  }

  contactInfo() {
    var otpInfo: any = {};
    otpInfo.phoneNbr = this.bi.phoneNbr;
    otpInfo.maMembershipId = this.nms.mlid;
    otpInfo.category = "ONBOARDING_OTP"; 
    return otpInfo;
   }

  msgToast(msg) {
    this.messageService.add({ severity: 'error', summary: 'Edit Member', detail: msg });
  }
}
